<template>
  <div ref="flexBox" :style="style" class="flex-box">
    <slot v-if="show"></slot>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { getFontSize } from '@/rem'
  export default {
    name: 'Flex',
    data() {
      return {
        show: true,
        style: 'flex: 1; display: flex; width: 100%; height: 100%',
        defaultStyle: 'flex: 1; display: flex; width: 100%; height: 100%',
        timer: false
      }
    },
    computed: {
      ...mapGetters([
        'screenWidth',
        'screenHeight'
      ])
    },
    mounted() {
      this.resolveStyle()
    },
    watch: {
      screenHeight() {
        if (!this.timer) {
          this.timer = true
          setTimeout(() => {
            this.resize()
            this.timer = false
          }, 10)
        }
      },
      screenWidth() {
        if (!this.timer) {
          this.timer = true
          setTimeout(() => {
            this.resize()
            this.timer = false
          }, 10)
        }
      }
    },
    methods: {
      resize: function() {
        this.show = false
        this.style = this.defaultStyle
        this.$nextTick(() => {
          this.resolveStyle()
          this.show = true
          this.$nextTick(() => {
            this.$emit('resize', {
              width: this.$refs.flexBox.clientWidth,
              height: this.$refs.flexBox.clientHeight
            })
          })
        })
      },
      resolveStyle: function() {
        const baseSize = getFontSize()
        // console.log(baseSize)
        // const width = (this.$refs.flexBox.clientWidth) / baseSize
        // const height = (this.$refs.flexBox.clientHeight) / getFontSize()
        const width = this.$refs.flexBox.clientWidth
        const height = this.$refs.flexBox.clientHeight
        // console.log(this.$refs.flexBox)
        // console.log(width)
        // console.log(height)
        // this.style = 'width: ' + width + 'rem;height: ' + height + 'rem;'
        this.style = 'width: ' + width + 'px;height: ' + height + 'px;'
      }
    }
  }
</script>

<style scoped>
  /* .flex-box {
    width: 1383px;
    height: 658px;
  }*/
</style>